import React, { useEffect } from "react";

import HeaderMenu from "../../component/Navbar/headermenu";
import CustomFooter from "../../component/Footer/customFooter";
import { useData } from "../../OnBoard/DaysContext";
const CancellationRefundPolicy = () => {
  useEffect(() => {
    document.title = "Cancellation & Refund Policy - Simplifyte";
  }, []);

  const { days, loading } = useData();
  return (
    <>
      <HeaderMenu />
      <div className="p-4 md:p-8 max-w-4xl mx-auto text-gray-800">
        <h1
          className="font-size-same text-2xl font-bold mb-4"
          style={{ marginTop: "108px" }}
        >
          Refund Policy
        </h1>

        <p className="mb-4" style={{ textAlign: "justify" }}>
          We strive to be fair regarding payments, while recognizing the nature
          of digital subscriptions. This Refund Policy explains when refunds or
          credits are provided:
        </p>

        <ul
          className="policy-list list-disc list-inside space-y-2 mb-4"
          style={{ textAlign: "justify" }}
        >
          <li className="mb-4">
            <strong>Free Trial:</strong> Users get a{" "}
            {loading ? "...." : days || 14}-day free trial. No payment is taken
            during the trial; therefore, there is nothing to refund.
          </li>
          <li className="mb-4">
            <strong>Paid Subscription:</strong> {""}
            {/* After the trial, your chosen
            subscription plan is automatically billed. Once payment is made, all
            subscription fees are non-refundable, except as provided below. If
            you cancel, your access continues until the end of the paid period;
            no pro-rata refunds are given for partial use of the billing cycle. */}
            After the trial, your chosen subscription plan is automatically
            billed. Once payment is made, all subscription fees become
            non-refundable, except as provided below. If you cancel, your access
            continues until the end of the paid period; no pro-rata refunds are
            given for partial use of the billing cycle.
          </li>
          <li className="mb-4">
            <strong>Defective Service:</strong> {""}
            {/* If the Service has a major
            defect or is unavailable for an extended period due to our fault
            (beyond maintenance or force majeure), you may be eligible for a
            partial credit at our discretion. We will promptly remedy any
            functional issues. If the Service permanently fails to operate as
            described, you may request termination and refund of any unused
            fees. */}
            If the Service has a major defect or is unavailable for an extended
            period due to our fault (beyond maintenance or force majeure), you
            may be eligible for a partial credit at our discretion. We will
            promptly look into any of the functional issues. If the Service
            permanently fails to operate as described, you may request
            termination and avail the refund of any unused fees.
          </li>
          <li className="mb-4">
            <strong>Billing Errors:</strong> If an erroneous charge is made to
            your account (e.g. technical error or duplicate payment), we will
            correct it promptly and refund the mistaken amount. Customers should
            contact support immediately with transaction details.
          </li>
          <li className="mb-4">
            <strong>Provider Policies:</strong> {""}
            {/* Payments are processed by
            Razorpay (or other gateway). Their normal refund process returns
            money to your payment method in about 5–7 working days . We have no
            control over how quickly a bank processes the refund. */}
            Payments are processed by Razorpay (or other gateway). Their normal
            refund process returns money to your respective payment method in a
            week or fortnight . We have no control over the bank processes.
          </li>
          <li className="mb-4">
            <strong>Consumer Rights:</strong> {""}
            {/* Where Indian law (e.g. Consumer
            Protection Act) requires it, we provide remedies for defective
            digital services. For example, if you can prove a promised feature
            was not delivered, we will fix it or provide a service of similar
            value. */}
            Where Indian law requires it, we provide remedies for defective
            digital services. As in, if you can prove that a promised feature
            was not delivered, than either we will fix it or provide a service
            of similar value.
          </li>
          <li className="mb-4">
            <strong>How to Request:</strong> {""}
            {/* To request a refund or credit
            (within these terms), contact our billing support. Provide your
            account info and explanation. We will investigate and notify you of
            the outcome within a reasonable time. */}
            To request a refund or credit (within these terms), contact our
            billing support. Provide your account information and explanation.
            We will investigate and notify you within a short time.
          </li>
        </ul>
      </div>
      <CustomFooter />
    </>
  );
};

export default CancellationRefundPolicy;
